import { render, staticRenderFns } from "./MedicalRepList.vue?vue&type=template&id=6bf95684&"
import script from "./MedicalRepList.vue?vue&type=script&lang=ts&"
export * from "./MedicalRepList.vue?vue&type=script&lang=ts&"
import style0 from "./MedicalRepList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports